import { IInitAction } from './init'

export enum types {
  GET_GROUP_EDITORS__STARTED = 'GET_GROUP_EDITORS__STARTED',
  GET_GROUP_EDITORS__SUCCESS = 'GET_GROUP_EDITORS__SUCCESS',
  GET_GROUP_EDITORS__FAILURE = 'GET_GROUP_EDITORS__FAILURE',
  INVALIDATE_GROUP_EDITORS = 'INVALIDATE_GROUP_EDITORS',
}

export interface IGetGroupEditorsAction {
  type: types.GET_GROUP_EDITORS__STARTED
  groupId: string
  params?: IEditorsPerGroupParams
}

export interface IGetGroupEditorsSuccessAction {
  type: types.GET_GROUP_EDITORS__SUCCESS
  groupId: string
  editorsData: IGroupEditorsState
}

export interface IGetGroupEditorsFailureAction {
  type: types.GET_GROUP_EDITORS__FAILURE
  message: string
  groupId: string
  editorsData: IGroupEditorsState
}

export interface IInvalidateGroupEditorsAction {
  type: types.INVALIDATE_GROUP_EDITORS
  groupId: string
}

export type EditorsPerGroupActionsType =
  | IGetGroupEditorsAction
  | IGetGroupEditorsSuccessAction
  | IGetGroupEditorsFailureAction
  | IInvalidateGroupEditorsAction
  | IInitAction

export interface IEditor {
  id: string
  firstName: string
  middleName: string
  lastName: string
  email: string
  employeeId: string
}

export interface IEditorsPerGroupParams {
  skip: number
  take: number
}

export interface IGroupEditorsData {
  items: IEditor[]
  totalCount: number
}

export interface IGroupEditorsState {
  items: IEditor[] | null
  totalCount: number | null
  isLoading: boolean
  isFailed: boolean
}

export interface IEditorsPerGroup {
  [key: string]: IGroupEditorsState
}
